import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useContext } from 'react';
import AccordionContext from './AccordionContext.js';
import { AccordionItem as AccordionItem$2, AccordionHeader, AccordionHeaderContent, AccordionSubHeader, AccordionContentWrapper, AccordionContent } from './Accordion.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CHEVRON_DOWN } from '../../icons/ICON_UI_CHEVRON_DOWN.js';

var _excluded = ["children", "header", "index", "subHeader"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AccordionItem = function AccordionItem(_ref) {
  var children = _ref.children,
    header = _ref.header,
    index = _ref.index,
    _ref$subHeader = _ref.subHeader,
    subHeader = _ref$subHeader === void 0 ? undefined : _ref$subHeader,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AccordionContext),
    openIndices = _useContext.openIndices,
    toggleAccordion = _useContext.toggleAccordion;
  var isExpandable = !!children;
  var regionId = "sect".concat(index);
  return /*#__PURE__*/jsxs(AccordionItem$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/jsxs(AccordionHeader, _objectSpread(_objectSpread({}, isExpandable ? {
      'aria-controls': regionId,
      'aria-expanded': openIndices.includes(index),
      $isOpen: openIndices.includes(index),
      onClick: function onClick() {
        return toggleAccordion(index);
      },
      type: 'button'
    } : {
      as: 'div'
    }), {}, {
      children: [/*#__PURE__*/jsxs(AccordionHeaderContent, {
        children: [header, subHeader && /*#__PURE__*/jsx(AccordionSubHeader, {
          children: subHeader
        })]
      }), isExpandable && /*#__PURE__*/jsx(Icon, {
        className: "uikit-accordion-icon",
        path: ICON_UI_CHEVRON_DOWN,
        size: "xs",
        sizeMobile: "xxs"
      })]
    })), isExpandable && /*#__PURE__*/jsx(AccordionContentWrapper, {
      $isOpen: openIndices.includes(index),
      children: /*#__PURE__*/jsx(AccordionContent, {
        id: regionId,
        role: "region",
        $isOpen: openIndices.includes(index),
        children: children
      })
    })]
  }));
};
var AccordionItem$1 = AccordionItem;

export { AccordionItem$1 as default };
//# sourceMappingURL=AccordionItem.js.map
